export const styles = {
  container:
    "pt-hyam-navbar-h-sm xl:pt-hyam-navbar-h-xl",
  //"pt-hyam-navbar-h-sm xl:pt-hyam-navbar-h-xl",
  slice_rich_text_container: "hyam-cols",
  slice_rich_text_content_container:
    "col-span-2 md:col-span-6 xl:col-span-8",
};

export type HyamPrismicDocumentPageStyles =
  typeof styles;
